import React from 'react';

const FlowCard = ({ flow, onClick, onDelete }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="flow-card" onClick={onClick}>
      <h3>{flow.name}</h3>
      <p>Last modified: {formatDate(flow.lastModified)}</p>
      <div className="flow-card-actions" style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
        <button
          className="btn btn-primary"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
        >
          Open
        </button>
        {onDelete && (
          <button
            className="btn btn-danger"
            style={{ background: '#ff4d4f', color: 'white', border: 'none', padding: '0.5rem 1rem', borderRadius: '4px', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
};

export default FlowCard; 

